// 手机验证码相关功能
import apis from "@/config/apis";
import yqyapis from "@/config/yqyapis";
import { Toast } from "vant";
export default {
  data: () => ({
    captchaDisabled: false,
    captchaDisabledOverTime: null
  }),
  methods: {
    // 外界实际调用的方法
    async onClickGetCaptcha(phone, type) {
      // 通过锁来控制是否发送请求
      if (!this.captchaDisabled) {
        if (type === 1) {
          this.fetchPhoneCaptchaUser(phone);
        }
        if (type === 3) {
          yqyapis.member.sendSmsCode(phone);
        }
        else {
          this.fetchPhoneCaptcha(phone);
        }
      }
    },
    // 其余验证码接口，会返回用户是否注册

    async fetchPhoneCaptchaUser(phone) {
      try {
        const resp = await apis.common.getPhoneCaptcha(phone);
        const { success, msg, status } = resp;
        if (success === "ok") {
          this.checkCaptcha();
          Toast.success(msg);
        } else if (status === "1202") {
          this.showPopup = true; // 在手机号没有通过微信注册情况下，弹窗提示先去微信登录
        } else {
          Toast.fail("发送失败");
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 发送短信接口的处理
    // 登录的验证码接口，不会检测用户是否注册
    async fetchPhoneCaptcha(phone) {
      try {
        const resp = await apis.common.getPhoneCaptchaUser(phone);
        const { success, msg } = resp;
        if (success === "ok") {
          this.checkCaptcha();
          Toast.success(msg);
        } else {
          Toast.fail("发送失败");
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 处理重新获取验证码的倒计时
    checkCaptcha() {
      this.captchaDisabled = true;
      this.captchaDisabledOverTime = 60;
      let timer = setInterval(() => {
        let overtime = this.captchaDisabledOverTime;
        if (overtime <= 1) {
          this.captchaDisabled = false;
          this.captchaDisabledOverTime = null;
          clearInterval(timer);
        } else {
          this.captchaDisabledOverTime = --overtime;
        }
      }, 1000);
    }
  }
};
